import { useEffect, useState } from 'react';
import { calculateMainStartValueAndIncrementRate, parseDate } from 'debtClockUtils';

const MAIN_INTERVAL = 1000;
const UPDATE_INTERVAL = 1800000;

const emptyConfig = {
  debtMain: null,
  incrementRateMain: null,
  debtShare: null,
  incrementRateShare: null,
  population: null,
  startDebt: null,
  endDebt: null,
  startDate: null,
  endDate: null,
  initialized: false,
};

export default function useDebtClockConfig(province, debt_data) {
  const [debtConfigState, setDebtConfigState] = useState(emptyConfig);

  useEffect(() => {
    const setDebtConfig = () => {
      const rawClockData = debt_data?.[province];
      if (!rawClockData) {
        return;
      }
      const clock_data = {
        ...rawClockData,
        startDate: parseDate(rawClockData.startDate),
        endDate: parseDate(rawClockData.endDate),
      };

      const debtConfigMain = calculateMainStartValueAndIncrementRate(
        clock_data,
        MAIN_INTERVAL
      );
      const debtConfigShare = calculateMainStartValueAndIncrementRate(
        clock_data,
        MAIN_INTERVAL,
        true
      );

      setDebtConfigState({
        debtMain: debtConfigMain.startValue,
        incrementRateMain: debtConfigMain.incrementRate,
        debtShare: debtConfigShare.startValue,
        incrementRateShare: debtConfigShare.incrementRate,
        startDebt: clock_data.startDebt,
        endDebt: clock_data.endDebt,
        startDate: clock_data.startDate,
        endDate: clock_data.endDate,
        population: clock_data.population,
        initialized: true,
      });
    };

    setDebtConfig();
    const intervalId = setInterval(setDebtConfig, UPDATE_INTERVAL);
    return () => clearInterval(intervalId);
  }, [debt_data, province]);

  return { debtConfigState, MAIN_INTERVAL };
}
